/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";
import { withRouter, BrowserRouter } from 'react-router-dom'
import BsyDashboardCenter from "../BsyDashboardCenter";
import './index.css';
import { BsyUtils } from "../../../utils/Utils";

export default class BsyDashboardDesignPreviewPane extends React.Component {

    static defaultProps = {
        dockItem: [],
        dockCorp: [],
        components: [],
        previewMode: "computer",
        customApp: {},
        dockApp: {},
        customDash: {},
        speedyEntry: {},
    };

    constructor(props) {
        super(props);
        this.state = {
            dockItem: props.dockItem,
            dockCorp: props.dockCorp,
            components: props.components,
            previewMode: props.previewMode,
            customApp: props.customApp,
            carouselMap: props.carouselMap,
            dockApp: props.dockApp,
            richText: props.richText,
            customDash: props.customDash,
            noticeBoard: props.noticeBoard,
            recentUse: props.recentUse,
            speedyEntry: props.speedyEntry,
            preferences:props.preferences,
            mode: props.mode,
            apps: props.apps,
            flowManagementType: props.flowManagementType
        };
        this.previewIframe = React.createRef();
    }

    componentDidMount() {
        this.getPreviewContext();
    }

    getPreviewContext = () => {
        this.props.getPreviewContext && this.props.getPreviewContext(this)
    }

    changePreviewMode = (f) => {
        this.setState({ previewMode: f })
    }

    render() {
        const { previewMode, components, dockCorp, dockItem, apps, customApp, dockApp, customDash,preferences, recentUse, speedyEntry, carouselMap, richText, noticeBoard, flowManagementType, mode } = this.state;
        return (
            <div className="BsyDashboardDesignPreviewPane">
                <div className="dashboardDesignPreviewContent">
                    {
                        previewMode === "computer" && <div className={`designPreviewComputer ${mode}`}>
                            <BrowserRouter>
                                <BsyDashboardCenter
                                    isPreview={true}
                                    components={components}
                                    dockCorp={dockCorp}
                                    dockItem={dockItem}
                                    customApp={customApp}
                                    carouselMap={carouselMap}
                                    richText={richText}
                                    noticeBoard={noticeBoard}
                                    flowManagementType={flowManagementType}
                                    dockApp={dockApp}
                                    customDash={customDash}
                                    recentUse={recentUse}
                                    speedyEntry={speedyEntry}
                                    preferences={preferences}
                                    apps={apps}
                                />
                            </BrowserRouter>
                        </div>
                    }
                    {
                        previewMode === "phone" && <div className="designPreviewPhone">
                            <div className="previewBody">
                                <iframe
                                    ref={this.previewIframe}
                                    src={window.rootDirectroy + "/dashboard/mobile"}
                                    className="box-preview"
                                    frameborder="0"
                                    style={{
                                        width: '100%',
                                        height: '100%'
                                    }}
                                    onLoad={() => {
                                        const styles = `
                                        .home-container {
                                            pointer-events: none;
                                        }
                                        .team-nav {
                                            pointer-events: none;
                                        }
                                      `;
                                        BsyUtils.injectStylesIntoIframe(this.previewIframe.current, styles);
                                    }}
                                >
                                </iframe>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}


